const STORAGE_KEY = "pendingEmailVerification";

type PendingEmailVerification = Record<string, string>;

const getStorageKey = (userType: string, userId?: string | number) =>
  `${userType}:${userId || ""}`;

const readPendingEmails = (): PendingEmailVerification => {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return value ? JSON.parse(value) : {};
  } catch {
    return {};
  }
};

const writePendingEmails = (data: PendingEmailVerification) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};

export const markEmailVerificationPending = (
  userType: string,
  userId: string | number | undefined,
  email?: string,
) => {
  if (!email) return;

  const pendingEmails = readPendingEmails();
  pendingEmails[getStorageKey(userType, userId)] = email;
  writePendingEmails(pendingEmails);
};

export const clearEmailVerificationPending = (
  userType: string,
  userId: string | number | undefined,
) => {
  const pendingEmails = readPendingEmails();
  delete pendingEmails[getStorageKey(userType, userId)];
  writePendingEmails(pendingEmails);
};

export const isEmailVerificationPending = (
  userType: string,
  userId: string | number | undefined,
  email?: string,
) => {
  if (!email) return false;

  const pendingEmails = readPendingEmails();
  return pendingEmails[getStorageKey(userType, userId)] === email;
};
